export const BRAND_ID = '24A45101-3406-427D-B0E9-014DCA72B99F';

